import barba from '@barba/core';
import axios from 'axios';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const loadingClass = 'loading-ajax-cards';
const resetClass = 'reset-checkboxes-is-active';

function ajax(options) {
  const { url, paginate = false } = options;
  const body = document.body;
  body.classList.add(loadingClass);

  axios.get(url).then((response) => {
    const html = response.data;
    const filterSection = document.getElementById('filters');

    barba.history.add(url, 'barba');

    const parser = new DOMParser();
    const resHTML = parser.parseFromString(html, 'text/html');
    const newContainer = resHTML.getElementById('ajax-cards');

    if (!newContainer) {
      throw new Error('Missing #ajax-cards in AJAX response');
    }

    const ajaxContainer = document.getElementById('ajax-cards');
    if (!ajaxContainer) {
      throw new Error('Missing #ajax-cards in current document');
    }

    const height = ajaxContainer.offsetHeight;
    ajaxContainer.style.height = `${height}px`;
    ajaxContainer.innerHTML = newContainer.innerHTML;
    ajaxContainer.style.height = 'auto';

    gsap.from('.js-ajax-card', {
      opacity: 0,
      y: 10,
      duration: 0.5,
      delay: 0.2,
      stagger: 0.1,
    });

    if (paginate) {
      gsap.to(window, {
        scrollTo: {
          y: filterSection,
          offsetY: () => document.getElementById('header')?.offsetHeight ?? 0,
        },
        duration: 0.2,
      });
    }
  }).catch((err) => {
    console.error(err);
  }).finally(() => {
    body.classList.remove(loadingClass);
  });
}

function updateFilters(filter) {
  const href = window.location.href;
  let url = href.includes('/page') ? href.split('/page')[0] : href.split('?filters')[0];

  if (filter.classList.contains('js-reset-checkboxes')) {
    const resetButtons = document.querySelectorAll('.js-reset-checkboxes');
    resetButtons.forEach((button) => button.classList.add(resetClass));

    const allCheckboxFilters = document.querySelectorAll('input[type="checkbox"].js-filter');
    allCheckboxFilters.forEach((checkBox) => {
      checkBox.checked = false;
    });
  } else if (filter.type === 'checkbox') {
    const resetButtons = document.querySelectorAll('.js-reset-checkboxes');
    resetButtons.forEach((button) => button.classList.remove(resetClass));
  }

  let filterId = filter.id;
  if (filterId.includes('mobile-')) {
    filterId = filterId.split('mobile-')[1];
  }

  const matches = Array.from(document.querySelectorAll(`.js-filter[id$="${filterId}"]`));
  matches.forEach((match) => {
    match.checked = filter.checked;
  });

  let updatedSelected = Array.from(document.querySelectorAll('.js-filter:checked'));

  updatedSelected = updatedSelected.filter((item) =>
    !item.id.includes('filter-all-types') && !item.classList.contains('js-reset-checkboxes')
  );

  updatedSelected = updatedSelected.filter((item) => !item.id.includes('mobile'));

  if (updatedSelected.length) {
    const qString = updatedSelected.reduce((p, c, i) => {
      return p + c.value + `${i < updatedSelected.length - 1 && updatedSelected.length > 1 ? ',' : ''}`;
    }, '?filters=');
    url += qString;
  }

  ajax({ url });
}

function paginate(link) {
  const url = decodeURIComponent(link.href);
  ajax({
    url,
    paginate: true,
  });
}

export default function() {
  document.addEventListener('click', (e) => {
    if (e.metaKey || e.ctrlKey) {
      return;
    }
  });

  document.addEventListener('change', (e) => {
    const target = e.target;
    const filter = target.closest('.js-filter');
    if (filter) {
      updateFilters(filter);
    }
  });

  document.addEventListener('click', (e) => {
    const clicked = e.target;
    const resetButton = clicked.closest('.js-reset-checkboxes');
    const paginateLink = clicked.closest('.js-filter-paginate-link');

    if (resetButton) {
      e.preventDefault();
      updateFilters(resetButton);
    }

    if (paginateLink) {
      e.preventDefault();
      paginate(paginateLink);
    }
  });

  // Hover prefetch safety-net for injected links
  document.addEventListener('mouseenter', (e) => {
    if (!(e.target instanceof Element)) return;

    const link = e.target.closest('#ajax-cards a[href]');
    if (!link) return;
    if (link.closest('[data-barba-prevent]')) return;
    if (link.href === window.location.href) return;

    let targetUrl;
    try {
      targetUrl = new URL(link.href, window.location.origin);
    } catch (_) {
      return;
    }

    if (targetUrl.origin !== window.location.origin) return;

    if (typeof barba?.prefetch === 'function') {
      barba.prefetch(targetUrl.href);
    }
  }, true);
}